import { createFileRoute } from "@tanstack/react-router";
import { SelectExamples } from "@/utils/design-system/examples-exports";

export const Route = createFileRoute("/demo/design-system/radix/select")({
  component: SelectExamples,
});
